import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import Helpers from "commons/helpers";
import Screens from "constants/screens";
import Constants from "constants/index";

import { RootState } from "store";
import { LoadingLayout } from "layout";
import { useAuth } from "providers/authProvider";

interface IProps {
    children: React.ReactElement;
}

const ProtectedRoute: React.FC<IProps> = (props: IProps) => {
    const auth = useAuth();
    const location = useLocation();

    const userInfo = useSelector((state: RootState) => state.user?.userInfo);
    const errorMessage = useSelector((state: RootState) => state.user?.errorMessage);

    if (auth?.loading) {
        return <LoadingLayout />;
    }

    if (!Helpers.isNullOrEmpty(errorMessage)) {
        Helpers.showAlert(errorMessage, "error", () => { auth.signoutRedirect() });
    }

    if (auth.user === null) {
        sessionStorage.setItem(Constants.StorageKeys.FROM, location.pathname);
        return <Navigate to={Screens.LOGIN_REDIRECT} replace />
    }

    return !Helpers.isNullOrEmpty(userInfo?.userProfile?.id) ? props.children : <LoadingLayout />;
};

export default ProtectedRoute;
